import React from "react";
import LabelDisplay from "../LabelDisplay/LabelDisplay";
import { ageCalculator } from "../../utils/ageCalculator";
import { fullAddress, fullName } from "../GlobalComponents/GlobalComponents";
import FormatDate from "../FormatDate/FormatDate";
import { useStateGlobalContext } from "../../contexts/GlobalContext";

const PatientInformation = ({ patient }) => {
  const { officeSetting } = useStateGlobalContext();
  const timezone = officeSetting?.facility_time_zone || 'UTC';
  return (
    <div className="patient-info">
      <p className="font-semibold">Patient Information</p>
      <LabelDisplay title="Name" description={fullName(patient)} />
      <LabelDisplay
        title="DOB"
        description={<FormatDate date={patient?.date_of_birth} />}
      />
      <LabelDisplay
        title="Age"
        description={`${ageCalculator(patient?.date_of_birth, timezone)} y/o`}
      />
      <LabelDisplay title="Gender" description={patient?.gender} />
      <LabelDisplay title="Address" description={fullAddress(patient)} />
      <LabelDisplay
        title="Phone"
        description={patient && patient?.patient_phone}
      />
    </div>
  );
};

export default PatientInformation;
